import { LinkTracking } from '../context/tracking';
import { track } from '../track/track';

interface Payload extends LinkTracking {
  id: string;
  name: string;
  action?: string;
  key?: string; // TuKey zur Überleitung
  description?: string; //Bezeichner der Überleitung
  spk: string; // blz
  onTrack?: () => void;
}

/**
 * @once
 */
export const trackSparkasseAssignmentForm = ({
  id,
  name,
  action = 'ueberleitung assignmentform',
  key,
  description,
  linkType,
  linkText,
  linkHref,
  onTrack,
}: Payload): void => {
  track(
    'event.sparkasseassignmentform',
    { id, name, action, key, description, linkType, linkText, linkHref },
    { callback: onTrack, once: false }
  );
};
